import type { DesktopDiagnosticReportResult } from "@/lib/desktop/diagnostics";
import type { FeedbackContent } from "@/lib/feedback";

export type DesktopIssueSceneContents = {
  desktop_diagnostics?: string;
  desktop_diagnostics_status: "ready" | "unavailable";
};

const DESKTOP_DIAGNOSTICS_HEADING = "[Findin Desktop Diagnostics]";

export function buildDesktopIssueSceneContents(
  result: DesktopDiagnosticReportResult,
): DesktopIssueSceneContents {
  if (result.success) {
    return {
      desktop_diagnostics: result.report,
      desktop_diagnostics_status: "ready",
    };
  }

  return {
    desktop_diagnostics_status: "unavailable",
  };
}

export function transformDesktopIssueSubmitContent(
  content: Readonly<FeedbackContent>,
): FeedbackContent {
  const {
    desktop_diagnostics: diagnosticReport,
    desktop_diagnostics_status: diagnosticStatus,
    ...requestContent
  } = content;
  const userContent = typeof requestContent.content === "string"
    ? requestContent.content
    : "";
  const hasDiagnosticReport = diagnosticStatus === "ready"
    && typeof diagnosticReport === "string"
    && diagnosticReport.trim().length > 0;
  const status = hasDiagnosticReport ? "ready" : "unavailable";
  const diagnosticBlock = [
    "---",
    DESKTOP_DIAGNOSTICS_HEADING,
    `status=${status}`,
    ...(hasDiagnosticReport ? [diagnosticReport] : []),
  ].join("\n");

  return {
    ...requestContent,
    content: `${userContent}\n\n${diagnosticBlock}`,
  };
}
